import React, { useEffect, useState } from "react";
import PatientMonthlyTable from "./patientMonthlyTable";
import nodatafound from "../../../../../Assets/Images/Svg/nodatafound.svg";
import { Flex, Spin } from "antd";
import dayjs from "dayjs";
import PatientService from "../../../../../Services/PatientService";
import { APP_ROUTES } from "../../../../../PageRouting/approutes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function Index() {
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [patientsList, setPatientsList] = useState([]);
  const history = useHistory();
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    const fromDate = dayjs().startOf("month").format("MM/DD/YYYY");
    const toDate = dayjs().endOf("month").format("MM/DD/YYYY");

    const patPayload = {
      pageNo: currentPage,
      fromDate,
      toDate,
      rpmApplicable: "Y",
      status: 1,
      providerCode: loggedUser?.user?.userId,
      hospitalId: loggedUser?.user?.account_Id,
      locationId: loggedUser?.user?.clinic_Id,
    };

    // if (loggedUser?.user?.rolecode === "ACCT_ADM") {
    //     patPayload.account_Id = loggedUser.user.account_Id;
    // }
    // else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
    //     patPayload.account_Id = loggedUser.user.account_Id;
    //     patPayload.clinic_Id = loggedUser.user.clinic_Id;
    // }
    fetchPatients(patPayload);
  }, []);

  const fetchPatients = async (payload) => {
    setIsLoading(true);
    try {
      const response = await PatientService.PatientListRPM(payload);
      setPatientsList(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleViewAllPatients = () => {
    history.push(APP_ROUTES.PATIENTLIST);
  };

  return (
    <div className="mt-5 p-4 border rounded-md shadow-lg">
      <div className="flex items-center justify-between">
        <h2 className="font-semibold font-inter text-gray-800 text-base mb-2 flex gap-2 items-center">
          Patients List
          <span className="text-xs text-gray-500">(This Month)</span>
        </h2>
        {/* <button onClick={handleViewAllPatients} className="text-sm text-sky-500 cursor-pointer font-inter font-semibold">
                    View all
                </button> */}
      </div>
      <div className="overflow-auto rounded-lg border bg-white h-[350px] overflow-y-scroll scrollWidth mt-3">
        {isLoading === true && patientsList?.length === 0 ? (
          <div className="flex items-center justify-center mt-[10%]">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        ) : isLoading === false && patientsList?.length === 0 ? (
          <div className="flex flex-col items-center justify-center">
            <img src={nodatafound} alt="nodatafound" className="h-56 w-56" />
            <p className="font-medium text-lg">No data found!!</p>
          </div>
        ) : (
          <div>
            <PatientMonthlyTable data={patientsList} />
          </div>
        )}
      </div>
    </div>
  );
}

export default Index;
